import { useTranslation } from 'react-i18next';

function ApiSection() {
  const { t } = useTranslation();
  const features = t('api.features', { returnObjects: true });

  return (
    <section className="section api-section">
      <div className="api-card">
        <div className="api-content">
          <div className="eyebrow">{t('api.eyebrow')}</div>
          <h2>{t('api.title')}</h2>
          <p>{t('api.description')}</p>

          <ul className="feature-list">
            {features.map((feature) => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
        </div>

        <div className="code-preview" aria-label={t('api.previewAria')}>
          <div className="code-preview-header">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <pre>
            <code>{t('api.codePreview')}</code>
          </pre>
        </div>
      </div>
    </section>
  );
}

export default ApiSection;
